<template>
  <div v-if="onlyValue" :class="{'show-txt-rest':readonly,'blur-border': isFoucs,'visible-onlyValue': currentValue && currentValue.length > 0}" class="table-select-box add-task-range-time"  @click="getBlur">
      <div class="table-select-onlyValue" :class="dateReminder(currentValue)" v-if="currentValue && currentValue.length > 0">
        <template v-if="currentValue[0] == currentValue[1]">
          <span>{{currentValue[0] && currentValue[0].replace(/-/g,'/')}}</span>
        </template>
        <template v-else>
          <span>{{currentValue[0] && currentValue[0].replace(/-/g,'/')}}<span class="line">—</span>{{currentValue[1] && currentValue[1].replace(/-/g,'/')}}</span>
        </template>
      </div>
      <p v-else class="table-select-button">
        <span v-if="readonly">暂无</span>
        <span v-else><i class="el-icon-circle-plus"></i>添加</span>
      </p>
    <wf-date placement="bottom" type="daterange" value-format="yyyy-MM-dd" ref="inputLongText" :picker-options="pickerOptions" @blur="setBlurFoucs()" v-model="currentValue" @change="valueChange"></wf-date>
  </div>
  <div class="add-task-range-time" v-else>
    <div class="add-task-range-time-con" :class="{'show-txt-rest':readonly}" @click="getBlur">
      <div class="only-value show-txt" :class="dateReminder(currentValue)" v-if="currentValue && currentValue.length > 0">
        <span>{{currentValue[0].replace(/-/g,'/')}}<span class="line">-</span>{{currentValue[1].replace(/-/g,'/')}}</span>
        <i class="el-icon-circle-close" v-if="!readonly" @click.stop="delDay"></i>
      </div>
      <span v-else class="add-txt" :class="{ readonly }">{{readonly ? '暂无' : '添加'}}</span>
    </div>
    <wf-date placement="bottom" type="daterange" value-format="yyyy-MM-dd" ref="inputLongText" :picker-options="pickerOptions" @blur="setBlurFoucs()" v-model="currentValue" @change="valueChange"></wf-date>
  </div>
</template>

<script>
import { dateReminder } from '@/utils'
export default {
  props: ['config', 'value', 'defaultValue', 'onlyValue', 'readonly','taskStatus'],
  data() {
    let _this = this
    return {
      isFoucs: false,
      pickerOptions: {
        shortcuts: [{
          text: '一周',
          onClick(picker) {
            const start = new Date();
            const end = new Date();
            end.setTime(end.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(end.getTime() + 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(end.getTime() + 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '清空',
          cellClassName:'date-cancel del-text text-red',
          onClick(picker) {
            picker.$emit('pick', '');
          }
        }]
      },
    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value || [];
      },
      set: function (newValue) {
        this.$emit('input', newValue || null)
      }
    },
    complete() {
      return this.taskStatus === '已完成' ? true : false
    }
  },
  mounted() {
    this.getDefaultValue()
  },
  methods: {
    getDefaultValue() {
      if (this.defaultValue && this.defaultValue.length > 0 && this.defaultValue[0]) {
        this.$emit('input', [this.defaultValue[0], this.defaultValue[1]])
      }
    },
    getBlur() {
      if (this.readonly) return
      this.isFoucs = true
      this.$nextTick(() => {
        this.$refs.inputLongText.handleFocus()
      })
    },
    valueChange(val) {
      if(!val) {
        this.delDay()
      } else {
        this.$emit('change', val)
      }
    },
    setBlurFoucs() {
      this.isFoucs = false
    },
    delDay() {
      this.$emit('input', '')
      this.$nextTick(() => {
        this.$emit('change', '')
      })
    },
    dateReminder(time) {
      let result = dateReminder({
        task_stage: '',
        end_time: time[1]
      })
      let classStr = ''
      if (!time[0]) {
        classStr =  ''
      } else if (result === 'expired') {
        classStr =  'children-row  expired'
      } else if (result === 'remind') {
        classStr =  'children-row  remind'
      } else {
        classStr =  'children-row '
      }
      let c = this.complete ? 'compete-time' : ''
      return classStr + ' ' + c
    },
  }
}
</script>

<style lang="scss">
.el-date-table td.today span {
  color: $color-active;
  display: flex;
  flex-direction: column;
  align-items: center;
  &::after {
    content: "";
    display: flex;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: $color-active;
  }
}
.add-task-range-time {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 14px;
  position: relative;
  height: 100%;
  .table-select-button {
    line-height: 1;
  }
  &>div {
    height: 100%;
  }
  .add-task-range-time-con {
    display: flex;
    align-items: center;
  }
  .el-date-editor{
    position: absolute;
    z-index: -99999;
    visibility: hidden;
    left:0;
    bottom: 0;
    top:0;
    right:0;
    width: 100%;
    height: 100% !important;
  }
  .table-select-onlyValue{
    >span{
      display: flex;
      align-items: center;
    }
  }

  .select-day {
    position: absolute;
    z-index: -999;
    opacity: 0;
  }
  .remind {
    color: #ff8b23 !important;
  }
  .expired {
    color: #ff3939 !important;
  }
  .complete {
    background-color: #dcdee5 !important;
    color: rgba(117, 116, 142, 1) !important;
  }
  .compete-time{
    color: initial !important;
  }
  .only-value {
    white-space: nowrap;
    padding: 0 8px !important;
    .el-icon-circle-close {
      display: none;
      margin-left: 6px;
    }
    &:hover {
      .el-icon-circle-close {
        display: inline-block;
      }
    }
  }
  .line {
    background: transparent;
  }
}
</style>
